module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/abbr#_idParaDest-3"
    }
  }, [_c('i', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword#_idParaDest-8"
    }
  }, [_c('i', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/editors#_idParaDest-9"
    }
  }, [_vm._v("Editors’ Introduction: J. B. Lightfoot as Biblical Commentator")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/intro#_idParaDest-13"
    }
  }, [_vm._v("Introduction: External and Internal Evidences of the Authenticity and Genuineness of the Fourth Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/pt1#_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Commentary on John")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch1#_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus: The Logos Doctrine")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#_idParaDest-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prologue and the Preparation; the Word and the Witness (John 1)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus: Evidence of the Authenticity and Authorship of This Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idParaDest-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beginning of the Signs of the Messianic Times (John 2)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idParaDest-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus: The Chronology of St. John and the Synoptists")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idParaDest-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nicodemus and the New Birth (John 3)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idParaDest-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Samaritan Woman and the Courtier’s Child (John 4)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idParaDest-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sabbath Healing and the Aftermath (John 5)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread on Earth, Bread from Heaven (John 6)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idParaDest-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus the Temple at the Feast of Tabernacles (John 7)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idParaDest-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus: The Question of the Authenticity of John 7:53–8:11")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idParaDest-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus the Light and Abraham the Forefather (John 8)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#_idParaDest-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus and the Man Born Blind (John 9)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#_idParaDest-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Good Shepherd and His Lost Sheep (John 10)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12#_idParaDest-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Raising of Lazarus and the Plotting of the Foes (John 11)")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13#_idParaDest-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Annoying Anointing (John 12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixa#_idParaDest-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: External Evidence for the Authenticity of the Fourth Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixb#_idParaDest-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: More Internal Evidence for the Authenticity and Genuineness of St. John’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixc#_idParaDest-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Lightfoot and German Scholarship on John’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/authorindex#_idParaDest-48",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Author Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scriptindex#_idParaDest-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Scripture Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idParaDest-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("The Gospel of St. John")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ata#_idParaDest-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/legacy#_idParaDest-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lightfoot Legacy Set")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreivp#_idParaDest-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0